document.addEventListener("DOMContentLoaded", function() {
    let serviceSliders = document.querySelectorAll(".content-tabber");

    serviceSliders.forEach((slider) => {

        const tabLinks     = slider.querySelectorAll(".content-tabber--links li");
        const mobileSelect = slider.querySelector('.content-tabber--mobile_select select');

        mobileSelect.addEventListener('change', function(e) {
            e.preventDefault();

            let targetSlide    = this.value;
            let selectedOption = this.selectedOptions[0];
            let targetNumber   = selectedOption.dataset.number;

            reveal_content_tabber_slide(targetSlide, slider, targetNumber, tabLinks)

        });

        tabLinks.forEach((link) => {
            link.addEventListener("click", function(e) {
                e.preventDefault();

                if (!this.classList.contains("active")) {
                    let link = this.querySelector("a");
                    let targetSlide = link.getAttribute("data-target");
                    let targetNumber = link.getAttribute("data-number");

                    // change the mobile select
                    mobileSelect.value = targetSlide;

                    reveal_content_tabber_slide(targetSlide, slider, targetNumber, tabLinks)
 
                }
            });
        });
    });

});


function reveal_content_tabber_slide(targetSlide, slider, targetNumber, tabLinks) {

    // Deactivate all tab links
    tabLinks.forEach((tabLink) => {
        tabLink.classList.remove("active");
    });

    // Activate the clicked tab link
    slider.querySelector('.content-tabber--links li[data-target="' + targetSlide + '"]').classList.add("active");
    
    // Hide all slides
    slider
        .querySelectorAll(".content-tabber--slides__slide")
        .forEach((slide) => {
            slide.style.display = "none";
        });

    // Show the target slide
    let newSlide = slider.querySelector(
        `.content-tabber--slides__slide[data-slide="${targetSlide}"]`,
    );
    window.helpers.fadeIn(newSlide);

    let counter_number = slider.querySelector(
        ".content-tabber--counter__number",
    );
    counter_number.textContent = targetNumber;

}